import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "nullishToZero",
    standalone: false
})
export class NullishToZeroPipe implements PipeTransform {
  transform(value: number | string): number {
    if (!value) return 0;
    return +value;
  }
}
